export default "__VITE_ASSET__sTo4S1Tg__"